type InfoBannerType = {
  productId: string;
  salesChannel: ReadonlyArray<{
    context: string;
    tags: ReadonlyArray<string>;
  }>;
  countdown?: {
    dateTimeEnd: string;
    daysLabel: string;
    hoursLabel: string;
    minutesLabel: string;
    secondsLabel: string;
  };
  popin: {
    buttonLabel: string;
    color: string;
    image: string;
    subtitle: string;
    url: string;
    title: string;
  };
  startDate?: string;
  endDate?: string;
  toaster?: {
    color: string;
    illustration: string;
    subtitle: string;
  };
  title: string;
  subtitle: string;
  illustration: string;
  color: string;
};
export type InfoBannerData = {
  productInformationBanners: Array<InfoBannerType>;
};
export const getInfoBannerQuery = (productId: string) => `query {
    productInformationBanners(productId:"${productId}") {
        productId
        salesChannel {
          context
          tags
        }
        countdown {
          dateTimeEnd
          daysLabel
          hoursLabel
          minutesLabel
          secondsLabel
        }
        popin {
          title
          subtitle
          text: description
          buttonLabel
          url
          image
          color
        }
        startDate
        endDate
        toaster {
          title
          subtitle: description
          iconName
          illustration: picto
          color
        }
    }
  }`;
